module.exports = __webpack_public_path__ + "e9c3a453f3c17dd375ca6321744df1a6.png";